var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.items)?_c('div',[_c('b-dropdown',{staticClass:"dropdown",attrs:{"text":_vm.dropdownText,"right":"","variant":"outline-primary"}},_vm._l((_vm.items),function(item,i){return _c('b-dropdown-item',{key:i,on:{"click":function($event){return _vm.handleClick(i)}}},[_vm._v(" "+_vm._s(_vm.getItemName(item))+" ")])}),1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }